// extracted by mini-css-extract-plugin
export default {"root":"NextAppointment_root__KuerC","header":"NextAppointment_header__dc8aF"};